module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact/contact-banner.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70393296!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/contact/HomeContactBanner.vue
// module id = 160
// module chunks = 1